// extracted by mini-css-extract-plugin
export default {"shippingMethod":"CartPage_shippingMethod__C7+s+"};